import axios from 'axios';
import { Apis } from 'constants/apis';
import { getToken } from 'utils/token';

const updateSocialVideo = async (payload: any) => {
    const { data } = await axios.put(Apis.UPDATE_SOCIAL_VIDEOS, payload, { headers: { Authorization: getToken() } });
    return data;
};
export default updateSocialVideo;
